import LinkToDocusaurus from '../LinkToDocusaurus'
import { customScripts } from '../../docs-routes'

const LinkToCustomScriptDoc = () =>
  <LinkToDocusaurus path={customScripts}>
    Learn more in the DAI documentation
  </LinkToDocusaurus>

export default LinkToCustomScriptDoc
